import { IPcr } from '../../../features/pcr/store/pcr.types'
import { IPatientVitals } from '../../../features/vitals/store/vitals.types'
import Logger from '../../../services/logger.service'
import { setValueForPathWithCreate } from '../../object.util'

export const addVitalShock = (pcr: any): IPcr => {
  try {
    if (pcr.patient && pcr.patient.patientVitals?.length && pcr.patient.patientVitals[0].shockIndex === undefined) {
      pcr.patient.patientVitals.forEach((vital: IPatientVitals & { shockIndex?: string }) => {
        setValueForPathWithCreate(vital, 'shockIndex', '')
      })
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addPainScale: ${error}`)
    throw error
  }
}
